import {
  isScheduledMessageCancellable,
  isScheduledMessageDeletable,
  isScheduledMessageEditable,
  isScheduledMessageForceDispatchable,
  isScheduledMessageResendable,
  isScheduledMessageRetryable,
  isScheduledMessageTemplateSendable,
} from './utils';

export const SCHEDULED_MESSAGE_ACTIONS = {
  force_dispatch: {
    id: 'force_dispatch',
    label: 'Enviar agora',
    loadingLabel: 'Enviando...',
    description: 'Gera e envia a mensagem imediatamente',
    variant: 'primary',
    group: 'dispatch',
  },
  send_template: {
    id: 'send_template',
    label: 'Enviar template',
    loadingLabel: 'Enviando...',
    description: 'Abre a janela do WhatsApp com o template',
    variant: 'primary',
    group: 'dispatch',
  },
  resend: {
    id: 'resend',
    label: 'Reenviar mensagem',
    loadingLabel: 'Reenviando...',
    description: 'Reenvia o conteúdo já gerado',
    variant: 'primary',
    group: 'dispatch',
  },
  retry: {
    id: 'retry',
    label: 'Reprocessar',
    loadingLabel: 'Reprocessando...',
    description: 'Reenfileira o envio preso em processamento',
    variant: 'default',
    group: 'maintenance',
  },
  cancel: {
    id: 'cancel',
    label: 'Cancelar',
    loadingLabel: 'Cancelando...',
    description: 'Interrompe futuros envios deste agendamento',
    variant: 'danger',
    group: 'danger',
  },
  delete: {
    id: 'delete',
    label: 'Excluir',
    loadingLabel: 'Excluindo...',
    description: 'Remove o agendamento permanentemente',
    variant: 'danger',
    group: 'danger',
  },
};

const ACTION_ORDER = [
  'force_dispatch',
  'send_template',
  'resend',
  'retry',
  'cancel',
  'delete',
];

function isActionVisible(item, actionId) {
  switch (actionId) {
    case 'force_dispatch':
      return isScheduledMessageForceDispatchable(item);
    case 'send_template':
      return isScheduledMessageTemplateSendable(item);
    case 'resend':
      return isScheduledMessageResendable(item);
    case 'retry':
      return isScheduledMessageRetryable(item.status, item.updated_at);
    case 'cancel':
      return isScheduledMessageCancellable(item.status);
    case 'delete':
      return isScheduledMessageDeletable(item.status);
    default:
      return false;
  }
}

export function getScheduledMessageVisibleActions(item) {
  return ACTION_ORDER.filter((actionId) => isActionVisible(item, actionId)).map(
    (actionId) => SCHEDULED_MESSAGE_ACTIONS[actionId]
  );
}

export function getScheduledMessagePrimaryDispatchAction(item) {
  if (isScheduledMessageForceDispatchable(item)) {
    return SCHEDULED_MESSAGE_ACTIONS.force_dispatch;
  }
  if (isScheduledMessageTemplateSendable(item)) {
    return SCHEDULED_MESSAGE_ACTIONS.send_template;
  }
  if (isScheduledMessageResendable(item)) {
    return SCHEDULED_MESSAGE_ACTIONS.resend;
  }
  return null;
}

export function getScheduledMessageSecondaryActions(item) {
  const primaryId = getScheduledMessagePrimaryDispatchAction(item)?.id;
  return getScheduledMessageVisibleActions(item).filter(
    (action) => action.id !== primaryId
  );
}

export function canEditScheduledMessage(item) {
  return isScheduledMessageEditable(item?.status);
}

export function groupScheduledMessageActions(actions) {
  const groups = {
    dispatch: [],
    maintenance: [],
    danger: [],
  };

  actions.forEach((action) => {
    groups[action.group].push(action);
  });

  return [
    { id: 'dispatch', label: 'Envio', actions: groups.dispatch },
    { id: 'maintenance', label: 'Manutenção', actions: groups.maintenance },
    { id: 'danger', label: null, actions: groups.danger },
  ].filter((group) => group.actions.length > 0);
}

export function getScheduledMessageMenuGroups(item) {
  const visible = getScheduledMessageVisibleActions(item);
  return groupScheduledMessageActions(visible);
}

export function isScheduledMessageActionLoading(actionId, loadingState) {
  return loadingState.activeActionId === actionId;
}

export function getScheduledMessageActionHandler(actionId, handlers) {
  switch (actionId) {
    case 'force_dispatch':
      return handlers.onForceDispatch;
    case 'send_template':
      return handlers.onSendTemplate;
    case 'resend':
      return handlers.onResend;
    case 'retry':
      return handlers.onRetry;
    case 'cancel':
      return handlers.onCancel;
    case 'delete':
      return handlers.onDelete;
    default:
      return undefined;
  }
}
